
import URI from 'urijs';

import {
    SET_CAMERA_PARAMS,
    SET_MMS_POINT
} from '../sagas/mapmultiscene';

const initialState = {
    // `mmsPoint` contains attributes from clicked MMS_POINT in map
    mmsPoint: null,
    // `cameraParams` contains parameters from `cameraChange` event
    // fired from MultiScene
    // ToDO : maybe move to `multiscene` reducer
    cameraParams: null
};

function getMmsPointFromUrl() {
    let uri = new URI(window.location.href);
    let mmsPoint;
    let mms = uri.search(true).mms;
    if (mms) {
        let parts = mms.split(';');
        if (parts.length >= 2) {
            mmsPoint = {
                trj_name: parts[0],
                photo_name: parts[1]
            }
        }
    }
    return mmsPoint;
}

function getInitialState() {
    return {
        ...initialState,
        mmsPoint: getMmsPointFromUrl()
    };
}

function mapMultiScene(state = getInitialState(), action) {
    switch (action.type) {
        case SET_CAMERA_PARAMS:
            return {
                ...state,
                cameraParams: action.cameraParams
            };
        case SET_MMS_POINT:
            return {
                ...state,
                mmsPoint: action.mmsPoint
            };
        default:
            return state;
    }
}

export default mapMultiScene;
